import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export interface OptionData {
  id: string | number
  label: string
}

interface NewOptionData extends Omit<OptionData, 'label'> {
  id: string | number;
  label: React.ReactNode | string
}

const NO_AVAILABILITY_OPTION = 'no-availability'

export const getNoAvailabilityOption = (message: (string | JSX.Element)[]): NewOptionData => ({
  id: NO_AVAILABILITY_OPTION,
  label: (
    <Typography variant='content2' italic inlineStyles={{ color: '#898989' }}>
      {message}
    </Typography>
  ),
})

export const getHoursAndMinutes = (date: Date): string => format(date, 'HH:mm')

export const formatSelectOptions = (availabilityList: string[], noAvailabilityMessage: (string | JSX.Element)[]): NewOptionData[] => {
  if (availabilityList?.length === 0) return [getNoAvailabilityOption(noAvailabilityMessage)]

  return availabilityList.map(date => {
    const dateObject = new Date(date)
    return {
      id: String(dateObject),
      label: getHoursAndMinutes(dateObject),
    } as NewOptionData
  })
}

export const formatDateForRestriction = (date: string): Date => {
  if (!date) return
  
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return utcToZonedTime(date, timeZone)
}

export const formatDateTime = (selectedDate: Date, selectedHour: OptionData): string => {
  if (!selectedDate || !selectedHour) return

  const formattedHour = selectedHour && format(new Date(selectedHour.id), 'HH:mm:ss')
  const formattedDate = format(selectedDate, 'yyyy-MM-dd')
  return `${formattedDate}T${formattedHour}`
}

export const handleSelectHour = (hour: OptionData): OptionData => {
  if (hour.id === NO_AVAILABILITY_OPTION) return
  return hour
}